// Extract validation logic into a reusable function
const validateCart = async (cart) => {
  console.log("Validating cart:", cart);
  const GLASS_JAR_HANDLE = "frische-menue-huhn-mit-reis-im-glas";
  const IS_FROZEN_METAFIELD = "custom.isfrozen";
  let jarCount400g = 0; // Count for 400g variant
  let jarCount800g = 0; // Count for 800g variant
  let frozenCount = 0;

  // Validate cart rules
  for (const item of cart.items) {
    // Rule 1: Count Frische Menüs im Glas by variant
    const isJarProduct =
      item.title.includes("(im Glas)") ||
      item.product_title.includes("(im Glas)");
    const isFrozenProduct =
      item.title.includes("gefroren") ||
      item.product_title.includes("gefroren");
    if (isJarProduct) {
      if (item.variant_title === "400g") {
        jarCount400g += item.quantity;
      } else if (item.variant_title === "800g") {
        jarCount800g += item.quantity;
      }
    }

    if (isFrozenProduct) {
      frozenCount += item.quantity;
    }
  }

  // Prepare messages and validate rules
  const messages = [];
  let disableCheckout = false;

  // Rule 1: Validate multiples of 6 for Frische Menüs im Glas (400g variant)
  if (jarCount400g > 0 && jarCount400g % 6 !== 0) {
    // const shortfall = 6 - (jarCount400g % 6);
    messages.push(
      `Die Mindestbestellmenge für unsere Frische Menüs im Glas beträgt 6 Stück. Du kannst diese in weiteren 6er Schritten (12, 18, 24, ...) bestellen.`,
      // `You must purchase Frische Menüs im Glas (400g) in multiples of 6. You currently have ${jarCount400g}. Add ${shortfall} more to meet the rule.`
    );
    disableCheckout = true;
  }

  // Rule 2: Validate multiples of 6 for Frische Menüs im Glas (800g variant)
  if (jarCount800g > 0 && jarCount800g % 6 !== 0) {
    // const shortfall = 6 - (jarCount800g % 6);
    messages.push(
      `Die Mindestbestellmenge für unsere Frische Menüs im Glas (800g) beträgt 6 Stück. Du kannst diese in weiteren 6er Schritten (12, 18, 24, ...) bestellen. Selbstverständlich sind die verschiedenen Sorten miteinander kombinierbar.`,
      // `You must purchase Frische Menüs im Glas (800g) in multiples of 6. You currently have ${jarCount800g}. Add ${shortfall} more to meet the rule.`,
    );
    disableCheckout = true;
  }

  // Rule 3: Validate minimum 12 frozen items
  if (frozenCount > 0 && frozenCount < 12) {
    // const shortfall = 12 - frozenCount;
    messages.push(
      `Aufgrund des Eigenkühl-Effekts beträgt die Mindestbestellmenge unserer gefrorenen Frische Menüs 12 Stück.`,
      // `You must purchase at least 10 Frische Menüs (frozen). You currently have ${frozenCount}. Add ${shortfall} more to meet the rule.`,
    );
    disableCheckout = true;
  }

  return { messages, disableCheckout };
};

// Function to update the UI
const updateUI = (messages, disableCheckout) => {
  // Display messages
  const feedbackContainer = document.getElementById("cart-feedback");
  if (feedbackContainer) {
    feedbackContainer.innerHTML = "";
    if (messages.length > 0) {
      messages.forEach((message) => {
        const errorDiv = document.createElement("div");
        errorDiv.classList.add("alert", "alert-danger");
        errorDiv.textContent = message;
        feedbackContainer.appendChild(errorDiv);
      });
    }
  }

  // Disable checkout button if validation fails
  const checkoutButton = document.querySelector('[name="checkout"]');
  if (checkoutButton) {
    checkoutButton.disabled = disableCheckout;
  }

  if (messages.length > 0) {
    // add hidden class to cart-feedback if checkout button is disabled
    feedbackContainer.classList.remove("hidden");
  } else {
    // remove hidden class to cart-feedback if checkout button is enabled
    feedbackContainer.classList.add("hidden");
  }
};

// Function to fetch cart data and validate it
const fetchAndValidateCart = async () => {
  try {
    const response = await fetch("/cart.js");
    if (response.ok) {
      const cart = await response.json();
      const { messages, disableCheckout } = await validateCart(cart);
      updateUI(messages, disableCheckout);
    } else {
      console.error("Failed to fetch cart data:", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching cart data:", error);
  }
};

// Subscribe to cart update events
MinimogEvents.subscribe("ON_CART_UPDATE", async (cart) => {
  const { messages, disableCheckout } = await validateCart(cart);
  updateUI(messages, disableCheckout);
});

// Function to initialize the drawer observer
const initializeDrawerObserver = () => {
  // Select the drawer element
  const drawerElement = document.querySelector(".scd__wrapper");

  if (drawerElement) {
    // Create a MutationObserver to watch for changes
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          // Check if the drawer is open or closed
          if (drawerElement.classList.contains("hidden")) {
            console.log("Drawer is closed");
            // Perform your custom logic for when the drawer is closed
          } else {
            console.log("Drawer is opened");
            // Fetch and validate the cart when the drawer is opened
            fetchAndValidateCart();
          }
        }
      });
    });

    // Start observing the drawer element for attribute changes
    observer.observe(drawerElement, {
      attributes: true, // Configure it to listen to attribute changes
    });
  } else {
    console.error("Drawer element not found");
  }
};

// --- Fixed position for Back-in-Stock button on product page ---
// Klaviyo injects the button into #klaviyo-bis-button-container and re-renders it on variant change, often in a different place. We move it into #bis-fixed-container.

const moveBackInStockButton = () => {
  const container = document.getElementById("bis-fixed-container");
  if (!container) return;

  // Klaviyo uses #klaviyo-bis-button-container (prefer this), or .klaviyo-bis-trigger, or theme's .btn-back-in-stock
  const klaviyoContainer = document.getElementById("klaviyo-bis-button-container");
  const klaviyoWrapper = document.querySelector(".klaviyo-bis-trigger");
  const bisButton =
    document.querySelector(".btn-back-in-stock") ||
    document.querySelector('button[data-ally-identifier^="bis-button"]') ||
    document.querySelector('button[data-ks-back-in-stock]');

  const nodeToMove =
    klaviyoContainer ||
    (klaviyoWrapper && bisButton && klaviyoWrapper.contains(bisButton) ? klaviyoWrapper : null) ||
    bisButton;

  if (!nodeToMove) return;
  if (container.contains(nodeToMove)) return;

  container.innerHTML = "";
  container.appendChild(nodeToMove);
};

// Run move repeatedly for a short period (Klaviyo often re-injects the button after variant change with a delay)
const scheduleBISMove = () => {
  moveBackInStockButton();
  [100, 300, 600, 1000].forEach((ms) => setTimeout(moveBackInStockButton, ms));
};

// Hide the "Sold out" ATC button so only "Notify me when back in stock" shows; show Add to cart when variant is in stock.
// Sticky ATC bar at bottom: show ONLY when variant is in stock; hide when out of stock.
function hideSoldOutButton() {
  const form = document.querySelector("form.product-form.main-product");
  if (!form) return;
  const atc = form.querySelector(".add-to-cart, button[name='add']");
  if (!atc) return;
  const text = (atc.textContent || "").trim();
  const isSoldOut =
    atc.classList.contains("disabled") ||
    atc.hasAttribute("disabled") ||
    /sold\s*out/i.test(text);

  if (isSoldOut) {
    atc.style.setProperty("display", "none", "important");
  } else {
    atc.style.removeProperty("display");
  }

  // Sticky ATC bar: show only for in-stock variants; hide for out-of-stock
  const stickyBar = document.querySelector(".prod__sticky-atc");
  if (stickyBar) {
    if (isSoldOut) {
      stickyBar.style.setProperty("display", "none", "important");
      document.documentElement.classList.remove("stick-atc-show");
    } else {
      stickyBar.style.removeProperty("display");
    }
  }
}

// Run hideSoldOutButton after theme has updated the ATC (variant change can be async)
function scheduleHideSoldOutButton() {
  hideSoldOutButton();
  [50, 150, 350, 600].forEach(function (ms) {
    setTimeout(hideSoldOutButton, ms);
  });
}

// Keep subscription widget above buy buttons (Appstle may inject at bottom on refresh; move into placeholder)
function moveSubscriptionWidgetIntoPlaceholder() {
  const placeholder = document.getElementById("appstle-subscription-placeholder");
  const widget = document.getElementById("appstle_subscription_widget0");
  if (!placeholder || !widget) return;
  if (placeholder.contains(widget)) return;
  placeholder.appendChild(widget);
}

// Keep product URL in sync with selected variant so refresh preserves state (fixes subscription/out-of-stock layout)
function getUrlWithVariant(url, variantId) {
  if (!variantId) return url;
  const base = url.split("?")[0];
  const search = new URLSearchParams(window.location.search);
  search.set("variant", String(variantId));
  return base + "?" + search.toString();
}

function updateProductUrlFromForm() {
  const form = document.querySelector("form.product-form.main-product");
  if (!form) return;
  const idInput = form.querySelector('input[name="id"]');
  if (!idInput) return;
  const variantId = idInput.value && idInput.value.trim();
  if (!variantId) return;
  const newUrl = getUrlWithVariant(window.location.href, variantId);
  if (newUrl !== window.location.href) {
    window.history.replaceState({ path: newUrl }, "", newUrl);
  }
}

const initializeBackInStockPositioning = () => {
  const tpl = document.documentElement.getAttribute("data-template");
  if (tpl !== "product") return;

  scheduleBISMove();

  const root = document.querySelector(".main-product__blocks");
  if (!root || root._bisObserverAttached) return;
  root._bisObserverAttached = true;

  const observer = new MutationObserver(() => {
    scheduleBISMove();
    updateProductUrlFromForm();
    hideSoldOutButton();
    moveSubscriptionWidgetIntoPlaceholder();
  });
  observer.observe(root, { childList: true, subtree: true });

  hideSoldOutButton();
  moveSubscriptionWidgetIntoPlaceholder();
  [100, 300, 600, 1500].forEach((ms) => setTimeout(moveSubscriptionWidgetIntoPlaceholder, ms));

  const form = root && root.closest("form.product-form");
  if (form) {
    form.addEventListener("change", () => {
      scheduleBISMove();
      updateProductUrlFromForm();
      scheduleHideSoldOutButton();
      moveSubscriptionWidgetIntoPlaceholder();
    });
    form.addEventListener("input", () => {
      scheduleBISMove();
      updateProductUrlFromForm();
      scheduleHideSoldOutButton();
      moveSubscriptionWidgetIntoPlaceholder();
    });
    // Always keep URL in sync with selected variant (theme may not update URL; refresh then loses state)
    const productId = form.dataset.productId;
    if (productId && typeof MinimogEvents !== "undefined" && MinimogEvents.subscribe) {
      MinimogEvents.subscribe(productId + "__VARIANT_CHANGE", (variant) => {
        if (variant && variant.id) {
          const newUrl = getUrlWithVariant(window.location.href, variant.id);
          if (newUrl !== window.location.href) {
            window.history.replaceState({ path: newUrl }, "", newUrl);
          }
        }
        scheduleHideSoldOutButton();
      });
    }
    updateProductUrlFromForm();
  }
};

function initializeScript() {
  initializeDrawerObserver();
  initializeBackInStockPositioning();

  // Set up a polling function that periodically checks if the cart drawer exists
  setInterval(() => {
    const drawerElement = document.querySelector(".scd__wrapper");
    if (drawerElement && !drawerElement._hasObserver) {
      drawerElement._hasObserver = true;
      initializeDrawerObserver();
    }

    // On product page, keep the Back-in-Stock button anchored, URL in sync, Sold out hidden, subscription in placeholder
    if (document.documentElement.getAttribute("data-template") === "product") {
      moveBackInStockButton();
      updateProductUrlFromForm();
      hideSoldOutButton();
      moveSubscriptionWidgetIntoPlaceholder();
    }
  }, 1000); // Check every second
}

// Initialize the script when the DOM is loaded
document.addEventListener("DOMContentLoaded", initializeScript);

// Also try to initialize on Shopify events
document.addEventListener("page:load", initializeScript);
document.addEventListener("shopify:section:load", () => {
  initializeBackInStockPositioning();
});


// If the drawer is dynamically added to the DOM, use a MutationObserver to detect when it's added
const dynamicDrawerObserver = new MutationObserver(
  (mutationsList, observer) => {
    const drawerElement = document.querySelector(".scd__wrapper");
    if (drawerElement) {
      initializeDrawerObserver();
      // observer.disconnect(); // Stop observing once the drawer is found
    }
  },
);

// Start observing the document body for changes
dynamicDrawerObserver.observe(document.body, {
  childList: true,
  subtree: true,
});
